"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const components_1 = require("@alcumus/components");
const numericScoreToImageMap = {
    0: '/images/popularity/zerobar.svg',
    1: '/images/popularity/onebar.svg',
    2: '/images/popularity/twobar.svg',
    3: '/images/popularity/threebar.svg',
    4: '/images/popularity/fourbar.svg',
    5: '/images/popularity/fivebar.svg',
};
const PopularityScore = ({ score }) => {
    let scoreImage;
    switch (true) {
        case score === 100:
            scoreImage = 5;
            break;
        case score >= 80:
            scoreImage = 4;
            break;
        case score >= 60:
            scoreImage = 3;
            break;
        case score >= 40:
            scoreImage = 2;
            break;
        case score >= 20:
            scoreImage = 1;
            break;
        default:
            scoreImage = 0;
            break;
    }
    return (react_1.default.createElement(components_1.Image, { src: numericScoreToImageMap[scoreImage], alt: `${scoreImage}/5` }));
};
exports.default = PopularityScore;
